import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import useMobileLayout from 'Hooks/useMobileLayout';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
  },
  td: {
    padding: theme.spacing(1),
  },
  title: {
    flexBasis: '30%',
    flexShrink: 0,
  },
  clickableRow: {
    cursor: 'pointer',
    transition: 'all 0.5s ease-out',
    '&:hover': {
      backgroundColor: theme.palette.grey[100],
    },
  },
});

const TableRowItem = ({
  data,
  columns,
  className,
  classes,
  onRowClick,
  forceUseMobileLayout,
  ...rest
}) => {
  let isMobile = useMobileLayout();
  isMobile = forceUseMobileLayout || isMobile;

  const hasOnRowClick = (typeof onRowClick === 'function');
  return (
    <tr
      className={classNames(classes.root, className, {
        [classes.clickableRow]: hasOnRowClick,
      })}
      onClick={() => hasOnRowClick && onRowClick(data)}
      {...rest}
    >
      {columns.map(column => {
        let ColumnComponent = null;
        if (typeof column.render === 'function') {
          ColumnComponent = () => column.render(data);
        }
        return (
          <td className={classes.td}>
            {isMobile && (
              <Typography
                className={classes.title}
                variant={'h6'}
                color={'primary'}
                weight={'bold'}
              >
                {column.title}
              </Typography>
            )}
            {!ColumnComponent ? (
              <Typography
                variant={'h5'}
                color={'primaryGray'}
                weight={'book'}
              >
                {data[column.key]}
              </Typography>
            ) : (
              <ColumnComponent />
            )}
          </td>
        );
      })}
    </tr>
  );
};

TableRowItem.defaultProps = {
  className: '',
  data: null,
  columns: [],
  onRowClick: null,
  forceUseMobileLayout: false,
};

TableRowItem.propTypes = {
  data: PropTypes.array,
  columns: PropTypes.array,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onRowClick: PropTypes.func,
  forceUseMobileLayout: PropTypes.bool,
};

export default withStyles(styles)(TableRowItem);
